module.exports = __webpack_public_path__ + "img/01_cortesup.26bcdf70.png";